export const faqList = [
  {
    q: "52吃瓜网的内容是怎么汇总出来的？",
    a: "我们会在公开平台上追踪当日讨论度上升较快的话题，再把分散的信息按时间线整理成一条完整的事件记录，包括起因、进展与目前的官方回应状态，方便你快速了解某件事的来龙去脉。",
  },
  {
    q: "热榜上的“热度值”代表什么？",
    a: "热度值是对话题在一个统计周期内的讨论量、转发量与搜索关注度做加权后得到的相对数值，用来比较话题之间的关注差异，而不是绝对的人数。数值会随着讨论变化而实时更新。",
  },
  {
    q: "网站上的内容都是确定的结论吗？",
    a: "不是。热点事件在早期往往信息有限，我们会明确标注哪些是已确认的公开信息，哪些仍属于未经证实的传闻，并同步更新当事方的最新回应。请把它当作线索梳理，而不是最终定论。",
  },
  {
    q: "如何把线索或补充信息提供给你们？",
    a: "你可以在“联系我们”页面提交线索或补充说明，写清事件的基本情况和你掌握的信息来源。我们会先做基础核实，再决定是否整理成文，感谢每一份认真的补充。",
  },
  {
    q: "为什么有些话题很快就不再更新了？",
    a: "当话题的公开信息趋于稳定、没有新的回应或进展时，我们会停止追加更新，避免重复堆砌内容。如果后续出现新的关键信息，相关事件会被重新补充整理。",
  },
  {
    q: "浏览网站需要注册或付费吗？",
    a: "目前所有内容都可以免费浏览，无需注册。站内的分类浏览、热度排序与搜索功能均可直接使用，我们不设置阅读门槛。",
  },
];